const l = {
  name: "PlusSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 13L11 17H13V13H17V11H13V7H11L11 11H7V13H11Z" fill="currentColor"/>
</svg>
  `
};
export {
  l as PlusSmall
};
